"use client";
import * as React from "react";
const SvgCallSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 11.076-4.685-.542-2.24 2.24a13.375 13.375 0 0 1-5.858-5.858l2.249-2.249L4.923 0H.025C-.49 9.05 6.95 16.49 16 15.975v-4.899Z" }));
export {
  SvgCallSharp as default
};
